module.exports = "<!--loading Screen-->\n<div *ngIf=\"showLoaderValue\" class=\"loader text-center\">\n    <img src=\"assets/images/copper-loader.gif\" class=\"loader-gif\" />\n</div>\n<div *ngIf=\"status\" class=\"loader text-center\">\n    <p class=\"roboto grey loader-pad\">\n        <b>{{ message | translate}}...</b><br>\n        <img src=\"assets/images/copper-loader.gif\" class=\"loader-gif\" />\n    </p>\n</div>"


//////////////////
// WEBPACK FOOTER
// /codebuild/output/src185846418/src/src/app/loader/loader.component.html
// module id = ../../../../../src/app/loader/loader.component.html
// module chunks = main